import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"flush-table\"><a href=\"#cell-spacing\"></a> Flush Table </h1><div class=\"py-5\"> Use <code>.table-flush</code>  to reset the table and cells base styles so then style the cells individually. </div><div class=\"my-5\"><table class=\"table table-rounded table-flush\"><thead><tr class=\"fw-bold fs-7 text-danger border-bottom border-gray-200 py-4\"><th>Name</th><th>Position</th><th>Office</th><th>Age</th><th>Start date</th><th>Salary</th></tr></thead><tbody><tr class=\"py-5 fw-bold  border-bottom border-gray-300 fs-5\"><td>Tiger Nixon</td><td>System Architect</td><td>Edinburgh</td><td>61</td><td>2011/04/25</td><td>$320,800</td></tr><tr class=\"py-5 fw-bolder  border-bottom  border-gray-400 fs-4\"><td>Garrett Winters</td><td>Accountant</td><td>Tokyo</td><td>63</td><td>2011/07/25</td><td>$170,750</td></tr><tr class=\"py-5 fw-boldest border-bottom border-gray-500 fs-3\"><td>Ashton Cox</td><td>Junior Technical Author</td><td>San Francisco</td><td>66</td><td>2009/01/12</td><td>$86,000</td></tr></tbody></table></div>", 3)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <table class="table table-rounded table-flush">
          <thead>
            <tr
              class="fw-bold fs-7 text-danger border-bottom border-gray-200 py-4"
            >
              <th>Name</th>
              <th>Position</th>
              <th>Office</th>
              <th>Age</th>
              <th>Start date</th>
              <th>Salary</th>
            </tr>
          </thead>
          <tbody>
            <tr class="py-5 fw-bold  border-bottom border-gray-300 fs-5">
              <td>Tiger Nixon</td>
              <td>System Architect</td>
              <td>Edinburgh</td>
              <td>61</td>
              <td>2011/04/25</td>
              <td>$320,800</td>
            </tr>
            <tr class="py-5 fw-bolder  border-bottom  border-gray-400 fs-4">
              <td>Garrett Winters</td>
              <td>Accountant</td>
              <td>Tokyo</td>
              <td>63</td>
              <td>2011/07/25</td>
              <td>$170,750</td>
            </tr>
          </tbody>
        </table>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}